// import ApiService from "../../nhrc_apis/ApiService";

// const { UploadAPI } = ApiService; // ✅ ADD THIS

// export const uploadSingleFile = async (file, membershipId = 0) => {
//   if (!file) return null;

//   const formData = new FormData();
//   formData.append("file", file);
//   formData.append("membership_id", membershipId);
//   formData.append("file_type", "profile");

//   try {
//     const res = await UploadAPI.uploadFile(formData);

//     return (
//       res.data?.fileUrl ||
//       res.data?.url ||
//       res.data?.file_path ||
//       ""
//     );
//   } catch (error) {
//     console.error("UPLOAD ERROR:", error.response?.data || error);
//     throw error;
//   }
// };






// import ApiService from "../../nhrc_apis/ApiService";

// const { UploadAPI } = ApiService;

// export const uploadSingleFile = async (file, membershipId) => {
//   if (!file) return null;

//   if (!membershipId) {
//     console.error("❌ membershipId is missing during upload");
//     throw new Error("membershipId is required for file upload");
//   }

//   const formData = new FormData();
//   formData.append("file", file);
//   formData.append("membership_id", String(membershipId)); // ✅ REQUIRED
//   formData.append("file_type", "profile");

//   try {
//     const res = await UploadAPI.uploadFile(formData);

//     return (
//       res.data?.fileUrl ||
//       res.data?.url ||
//       res.data?.file_path ||
//       ""
//     );
//   } catch (error) {
//     console.error("UPLOAD ERROR:", error.response?.data || error);
//     throw error;
//   }
// };

import ApiService from "../../nhrc_apis/ApiService";

const { UploadAPI } = ApiService;

export const uploadSingleFile = async (
  file,
  membershipId,
  fileType = "profile" // ✅ default fallback
) => {
  if (!file) return null;

  if (!membershipId) {
    console.error("❌ membershipId is missing during upload");
    throw new Error("membershipId is required for file upload");
  }

  const formData = new FormData();

  formData.append("file", file);
  formData.append("membership_id", String(membershipId)); // ✅ REQUIRED
  formData.append("file_type", fileType); // ✅ DYNAMIC

  try {
    console.log("📤 Uploading:", {
      membershipId,
      fileType,
      fileName: file.name,
    });

    const res = await UploadAPI.uploadFile(formData);

    const url =
      res.data?.fileUrl ||
      res.data?.url ||
      res.data?.file_path ||
      "";

    console.log("✅ Uploaded:", url);

    return url;

  } catch (error) {
    console.error("❌ UPLOAD ERROR:", error.response?.data || error);
    throw error;
  }
};